import { render, staticRenderFns } from "./OpenInClientUiButton.vue?vue&type=template&id=64a002c8&scoped=true"
import script from "./OpenInClientUiButton.vue?vue&type=script&lang=js"
export * from "./OpenInClientUiButton.vue?vue&type=script&lang=js"
import style0 from "./OpenInClientUiButton.vue?vue&type=style&index=0&id=64a002c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a002c8",
  null
  
)

export default component.exports